import React from 'react';

interface ButtonApprovalProps {
  isDisabled: boolean | undefined;
  onClick: () => void;
  label: string;
}

export const ButtonApproval: React.FC<ButtonApprovalProps> = ({ isDisabled, onClick, label }) => {
  return (
    <button
      className={`${
        !isDisabled
          ? 'mt-4 flex h-12 w-full items-center justify-center rounded-lg bg-[#0C1FAA] px-4 py-1 font-medium text-white'
          : 'mt-4 flex h-12 w-full items-center justify-center rounded-lg bg-[#0C1FAA] px-4 py-1 font-medium text-white focus:outline-none disabled:opacity-25'
      }`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {label}
    </button>
  );
};
